// t() reads the page language, which the compiler cannot see, and this stays
// on screen while the language changes.
"use no memo";
import { t, useLocale } from "../i18n";
import { EntryReveal } from "../ui/entry-reveal";

const steps = [
  ["أنشئ رابط مكالمة", "اختر اسمًا مستعارًا واحصل على رابطك بضغطة واحدة."],
  ["أرسله لمن تريد", "شاركه في أي تطبيق. يكتب اسمه وينضم دون حساب."],
  [
    "تحدثا وابقيا على تواصل",
    "اتصلا بالصوت أو الفيديو، ثم ابقيا على تواصل إن أردتما.",
  ],
] as const;

export function HomeGuide({ paused }: { paused: boolean }) {
  const locale = useLocale();
  const arabic = locale === "ar";
  return (
    <div className="home-guide">
      <EntryReveal
        as="section"
        className="guide-steps"
        aria-labelledby="steps-title"
        lang={locale}
        paused={paused}
        onView
      >
        <p className="eyebrow" data-ascii="skip">
          {t("من الرابط إلى المكالمة")}
        </p>
        <h2 id="steps-title" data-ascii={arabic ? "fade" : undefined}>
          <span data-ascii={arabic ? "skip" : undefined}>
            {t("ثلاث خطوات للبدء")}
          </span>
        </h2>
        <ol>
          {steps.map(([title, description]) => (
            <li key={title}>
              <h3 data-ascii={arabic ? "fade" : undefined}>
                <span data-ascii={arabic ? "skip" : undefined}>{t(title)}</span>
              </h3>
              <p data-ascii="skip">{t(description)}</p>
            </li>
          ))}
        </ol>
      </EntryReveal>
    </div>
  );
}
